/**
 * アプリ全体で共有する「背景スクロールのロック」マネージャ。
 *
 * これまで各オーバーレイ／メニューがそれぞれ
 *   const prev = el.style.overflow; el.style.overflow = 'hidden';
 *   return () => { el.style.overflow = prev; };
 * を個別に行っていたため、複数のロックが同時に重なると解除の順番で
 * 「後から解除した側が、自分が保存した 'hidden' を書き戻してしまい、ページが
 * 二度とスクロールできなくなる」不具合が起きていた。
 * （ログアウト時にハンバーガーメニュー／通知パネルのロックとログアウト幕のロックが
 *   重なり、PWA では全リロードされないため再ログイン後もアプリを終了するまで戻らない）
 *
 * ここでは参照カウント方式にして、
 *  - 最初のロック取得時にだけ「元の overflow」を保存してロック
 *  - 最後のロック解放時にだけ元へ戻す
 * ことで、ロックの重なりや解除順に依存せず安全に復元する。
 * このアプリは横スクロール対策で html に overflow-x: clip を当てているため、
 * body だけでなく html もロックする。
 */

let lockCount = 0;
let savedHtmlOverflow = '';
let savedBodyOverflow = '';

/** 背景スクロールのロックを1つ取得する（取得した数だけ release を呼ぶこと）。 */
export function acquireScrollLock() {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    const htmlEl = document.documentElement;
    const bodyEl = document.body;
    // 最初のロック取得時だけ「元の値」を保存する（重なったロックは同じ元値へ戻す）。
    savedHtmlOverflow = htmlEl.style.overflow;
    savedBodyOverflow = bodyEl.style.overflow;
    htmlEl.style.overflow = 'hidden';
    bodyEl.style.overflow = 'hidden';
  }
  lockCount += 1;
}

/** 背景スクロールのロックを1つ解放する。すべて解放されたときだけ元の値へ戻す。 */
export function releaseScrollLock() {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.documentElement.style.overflow = savedHtmlOverflow;
    document.body.style.overflow = savedBodyOverflow;
  }
}